import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { MyGlobal, MyAlert } from '../GlobalContext';
import { Link } from 'react-router-dom';

export class ViewManifest extends Component {
    static displayName = ViewManifest.name;

    constructor(props) {
        super(props);
        this.state = {
            selectedManifest: props.location.state,
            loading: true,
            alertMessage: "",
            manifestDetails: "",
            manifestDocketDetails: [],
            selectedCarrierName: "",
            selectedManifestNumber: "",
            selectedA4PrinterId: 0,
            uploadedImageData:""
        };
        this.history = props.history;

    }

    componentDidMount() {
        if (MyGlobal.print_settings) {
            var globalPrintSettings = JSON.parse(MyGlobal.print_settings);
            if (globalPrintSettings) {
                this.setState({
                    selectedA4PrinterId: globalPrintSettings.selectedA4PrinterId
                });
            }
        }

        this.getManifestDetails();
    }
    goto(page) {
        this.history.push(page);
    }

    getManifestDetails() {
        this.setState({ loading: true, alertMessage: "" });
        fetch(`api/Manifest/GetManifestDetails?manifestNumber=${this.state.selectedManifest.manifestNumber}&carrierId=${this.state.selectedManifest.carrierId}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Manifests!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ manifestDetails: data.z_Manifest_Data, manifestDocketDetails: data.manifestDocketDetails });
                            if (data && data.manifestDocketDetails && data.manifestDocketDetails.length > 0) {
                                var firstRecord = data.manifestDocketDetails[0];
                                this.setState({ selectedCarrierName: firstRecord.carrierName, selectedManifestNumber: firstRecord.manifestNumber });
                            }
                            if (data && data.z_Manifest_Data && data.z_Manifest_Data.image) {
                                this.setState({ uploadedImageData: "data:image/jpeg;base64, " + data.z_Manifest_Data.image});
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Manifests!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Manifests!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    printManifest() {
       
        if (!this.state.selectedA4PrinterId) {
            this.setState({ loading: false, alertMessage: "Please select a valid Printer" });
            return;
        }
        this.setState({ loading: true, alertMessage: "" });
        fetch(`api/Manifest/PrintManifest?manifestNumber=${this.state.selectedManifest.manifestNumber}&carrierId=${this.state.selectedManifest.carrierId}&printerId=${this.state.selectedA4PrinterId}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to print Manifest!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "Print sent" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to print Manifest!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to print Manifest!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    render() {

        const pagination = paginationFactory({
            page: 2,
            sizePerPage: 5,
            lastPageText: '>>',
            firstPageText: '<<',
            nextPageText: '>',
            prePageText: '<',
            showTotal: true,
            alwaysShowAllBtns: true
        });

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const defaultSorted = [{
            dataField: 'DateManifested',
            order: 'desc'
        }];
        const columns = [
            { dataField: 'reference', text: 'Reference' },
            { dataField: 'pallets', text: 'Pallets' },
            { dataField: 'packages', text: 'Packages' },
            
        ];


        return <div className="container" >
            {this.state.loading && <div> <em>Loading ... </em></div>}
            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                        <h5>Manifest Details</h5>
                        {alertMessage}
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "ManifestHistory" }}>Back</Link>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Manifest Number :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.selectedManifestNumber}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Carrier Name :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.selectedCarrierName}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <label>Uploaded Image :</label>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <img src={this.state.uploadedImageData} />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.printManifest()} >Print</button>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <BootstrapTable keyField='docket' data={this.state.manifestDocketDetails} columns={columns} pagination={pagination} />
                    </Col>
                </Row>
            </Container>
           
        </div>
    }


}
